import { Controller } from '@hotwired/stimulus';

import { Splide } from '@splidejs/splide';
import { Video } from '@splidejs/splide-extension-video';

// Connects to data-controller="splide"
export default class extends Controller {
  static values = {
    type: { type: String, default: 'slide' },
    arrows: { type: Boolean, default: true },
    perPage: { type: Number, default: 1 },
  };

  connect() {
    new Splide(this.element, {
      type: this.typeValue,
      arrows: this.arrowsValue,
      perPage: this.perPageValue,
      perMove: 1,
    }).mount({
      Video,
    });
  }
}
